// Bridge for non-React modules (axiosConfig.js, ajax.js) to trigger the error modal.
let globalErrorCallback = null;

export const setGlobalErrorHandler = (handler) => {
  globalErrorCallback = handler;
};

export const triggerGlobalError = (message = "Something went wrong, please try again later") => {
  if (globalErrorCallback) {
    globalErrorCallback(message);
  }
};

export const isServerError = (statusCode) => {
  return statusCode === 500 || statusCode === 502;
};
